import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Constants } from 'src/app/constants';

@Component({
    selector: 'app-dashboard-settings',
    templateUrl: './dashboard-settings.component.html',
    styleUrls: ['./dashboard-settings.component.scss'],
    standalone: false // NOSONAR
})
export class DashboardSettingsComponent implements OnInit {
  selectAllCheckBox: boolean = false;
  preferenceList:any[]=[];
  checkboxItemsCopy: any;

  constructor(public constants:Constants,public dialogRef:MatDialogRef<DashboardSettingsComponent>,@Inject(MAT_DIALOG_DATA) public data:any) { }

  ngOnInit(): void {
    this.preferenceList=this.data.coldef;
    if(this.data.coldef) {
      this.preferenceList = this.data.coldef;
      this.preferenceList.forEach(element => {
           element['checkVar']=!element.hidden;     
      });
    this.checkboxItemsCopy = [];
      this.preferenceList.forEach(val => this.checkboxItemsCopy.push(Object.assign({}, val)));
      this.checkSelectAll();
    }
   
  }

  checkSelectAll() {
    if(this.preferenceList.length) {
      const unSelectedFound = this.preferenceList.find(item => item.checkVar == false);  // NOSONAR
      if(unSelectedFound) {
        this.selectAllCheckBox = false;
      } else {
        this.selectAllCheckBox = true;
      }
    }
 }
 
 getCheckedItems() {
  const checkedItems = this.preferenceList;
  for (let index = 1; index <= checkedItems.length; index++) {
    checkedItems[index-1].colIndex=index;
  }
  this.dialogRef.close({
    data: checkedItems,
    button: 'SAVE'
  })
}
resetClick(){
  this.dialogRef.close({
    button: 'RESET'
  })
}
onClmnOptCancel() {
  this.dialogRef.close({
    button: 'CLOSE'
  })
}

preferences(item){
    item.hidden = !item.checkVar;
    this.checkSelectAll();
     
}

  onSelectAllChange(value) {
    // selectAllCheckBox value = true...
    if(value) {
      this.preferenceList?.forEach((col) => {
        col.hidden = false;
        col.checkVar=true;
      })
      
    } else {
      // selectAllCheckBox value = false...
      this.preferenceList?.forEach((col) => {
        col.hidden = true;
        col.checkVar=false;
      })
    }
  }
   upImage(event:MouseEvent,index:any){
     event.preventDefault();
     console.info('Index in UpImage',index);
     const tempCurrentUp = this.preferenceList[index];
     const tempUp = this.preferenceList[index-1];
     this.preferenceList[index]=tempUp;
     this.preferenceList[index-1]=tempCurrentUp;

   }
   downImage(event:MouseEvent,index:any){
    event.preventDefault();
    console.info('Index in DownImage',index);
    const tempCurrentDown = this.preferenceList[index];
     const tempDown = this.preferenceList[index+1];
     this.preferenceList[index]=tempDown;
     this.preferenceList[index+1]=tempCurrentDown;
  }
  // {
  //   "prefSeqId": 181,
  //   "colName": "ID",
  //   "name": "event_id",
  //   "colIndex": 0,
  //   "hidden": false,
  //   "width": 60
  // },
}
